function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { useTransition, a, useSpring } from '@react-spring/web';
import { useResizeObserver } from '@isyc-react/core/resize-observer';
import "./grid.style.scss";
const defaultGridQueries = [{
  pixels: 1200,
  columns: 4
}, {
  pixels: 992,
  columns: 4
}, {
  pixels: 768,
  columns: 3
}, {
  pixels: 576,
  columns: 2
}];
const defaultColumns = 1;
export const GridList = props => {
  const {
    items,
    queries = defaultGridQueries
  } = props;

  // With window resize match query hook
  // const columns = useMedia([{query: '(min-width: 1200px)', value: 4},
  // {query: '(min-width: 992px)', value: 4},
  // {query: '(min-width: 768px)', value: 3}], defaultColumns)

  const [columns, setColumns] = React.useState(defaultColumns);
  const {
    ref,
    width = 1
  } = useResizeObserver();
  React.useEffect(() => {
    if (width !== 1) {
      var _queries$find$columns, _queries$find;
      const match = (_queries$find$columns = (_queries$find = queries.find(q => q.pixels <= width)) === null || _queries$find === void 0 ? void 0 : _queries$find.columns) !== null && _queries$find$columns !== void 0 ? _queries$find$columns : defaultColumns;
      if (match !== columns) setColumns(match);
    }
  }, [width, columns]);
  const [heights, gridItems] = React.useMemo(() => {
    const heights = new Array(columns).fill(0);
    const gridItems = items.map((child, i) => {
      const column = heights.indexOf(Math.min(...heights));
      const x = width / columns * column;
      const y = (heights[column] += child.height / 2) - child.height / 2;
      return _objectSpread(_objectSpread({}, child), {}, {
        x,
        y,
        width: width / columns,
        height: child.height / 2
      });
    });
    return [heights, gridItems];
  }, [columns, items, width]);
  const transitions = useTransition(gridItems, {
    key: item => item.id,
    from: ({
      x,
      y,
      width,
      height
    }) => ({
      x: x - 40,
      y: y - 40,
      width,
      height,
      opacity: 0
    }),
    enter: ({
      x,
      y,
      width,
      height
    }) => ({
      x,
      y,
      width,
      height,
      opacity: 1
    }),
    update: ({
      x,
      y,
      width,
      height
    }) => ({
      x,
      y,
      width,
      height
    }),
    leave: {
      height: 0,
      opacity: 0
    },
    config: {
      mass: 5,
      tension: 500,
      friction: 100
    },
    trail: 25
  });
  const container = useSpring({
    height: Math.max(...heights)
  });
  return /*#__PURE__*/React.createElement(a.div, {
    ref: ref,
    className: "grid-list",
    style: container
  }, transitions((style, item) => /*#__PURE__*/React.createElement(a.div, {
    className: "grid-list-inner",
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-list-inner-item"
  }, typeof item.render === 'function' ? item.render({
    x: item.x,
    y: item.y,
    height: item.height,
    width: item.width,
    id: item.id
  }) : item.render))));
};